import { User } from "Models/User/@types";

const RoleUtils = {
    isCurator: (user?: User) => user && user.roles.includes('CURATOR'),
    isCommunity: (user?: User) => user && user.roles.includes('COMMUNITY'),
    isRegularUser: (user?: User) => user && !(user.roles.includes('CURATOR') || user.roles.includes('COMMUNITY') || user.roles.includes('ADMIN')),
    isAdmin: (user?: User) => user && user.roles.includes('ADMIN')
}

export default RoleUtils;